import { render } from "./SaveButtonBottom.vue?vue&type=template&id=cca47c56"
import script from "./SaveButtonBottom.vue?vue&type=script&lang=js"
export * from "./SaveButtonBottom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__